import { TRANSPARENT_PIXEL, type CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';

export interface BackgroundImageOpts {
  pieceId?: string;
  canvasWidth: number;
  canvasHeight: number;
}

export function buildBackgroundImage(opts: BackgroundImageOpts): CanvasJSONLikeObject {
  const { canvasWidth, canvasHeight } = opts;
  return {
    pieceId: opts.pieceId ?? 'background-image',
    type: 'Image',
    version: '7.1.0',
    imageFit: 'cover',
    originX: 'left',
    originY: 'top',
    left: 0,
    top: 0,
    width: canvasWidth,
    height: canvasHeight,
    scaleX: 1,
    scaleY: 1,
    src: TRANSPARENT_PIXEL,
    crossOrigin: 'anonymous',
    objectCaching: true,
    selectable: true,
    evented: true,
    filters: []
  };
}
